import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { CreateLessonBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const createLesson = createApiThunk<string, CreateLessonBody>(
  "lessons/createLesson",
  async (body, { extra: { teacherRepository } }) => {
    return teacherRepository!.createLesson(body);
  },
);

export const resetCreateLesson = createAction("lessons/resetCreateLesson");
